

import { persistor } from "../_helpers";
import axiosInstance from "../axios";
import axios from "axios";

const mainLogin = async (username, password, environment) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_LOGIN_API_BASEURL}/main-login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password, environment }),
    });

    const res = await handleResponse(response);
    if (!res.error) localStorage.setItem("main-login", "true");
    return res;
  } catch (error) {
    console.error("mainLogin error:", error);
    return { error: true, message: error.toString() };
  }
};

const login = async (username, password) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_LOGIN_API_BASEURL}/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: username, password }),
    });

    const res = await handleResponse(response);
    if (!res.error) {
      localStorage.setItem("token", JSON.stringify(res.data?.token));
    }
    return res;
  } catch (error) {
    console.error("login error:", error);
    return { error: true, message: error.toString() };
  }
};

const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("main-login");
  localStorage.removeItem("checkout-data");
  localStorage.removeItem("ck_session");
  persistor.purge();
};

const handleResponse = async (response) => {
  try {
    const text = await response.text();
    const data = text && JSON.parse(text);

    if (!response.ok) {
      if (response.status === 401) {
        logout();
        window.location.reload(true);
      }
      const error = (data && data.message) || response.statusText;
      throw new Error(error);
    }

    return data;
  } catch (error) {
    console.error("handleResponse error:", error);
    throw error;
  }
};

const getUserInfo = async () => {
  try {
    const res = await axiosInstance.get("user");
    return res;
  } catch (error) {
    console.error("getUserInfo error:", error.message);
    return null;
  }
};

const getGeoLocation = async () => {
  try {
    const res = await axios.get("https://geolocation-db.com/json/8dd79c70-0801-11ec-a29f-e381a788c2c0");
    return res;
  } catch (error) {
    console.error("getGeoLocation error:", error.message);
    return null;
  }
};

export const userService = {
  mainLogin,
  login,
  logout,
  getUserInfo,
  getGeoLocation,
};
